import { render, staticRenderFns } from "./restriktionen-date-picker.vue?vue&type=template&id=1bf88ac2&scoped=true"
import script from "./restriktionen-date-picker.vue?vue&type=script&lang=js"
export * from "./restriktionen-date-picker.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-date-picker.vue?vue&type=style&index=0&id=1bf88ac2&prod&scoped=true&lang=css"
import style1 from "./restriktionen-date-picker.vue?vue&type=style&index=1&id=1bf88ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf88ac2",
  null
  
)

export default component.exports